// extracted by mini-css-extract-plugin
module.exports = {"link-button":"_105329b597--link-button--ujZuh"};